import {Component} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
    selector: 'leads-list',
    templateUrl: 'leads.template.html',
    styleUrls: ['leads.component.css']
})
export class LeadsComponent{

    public _: any = _;
    public tabs;

    constructor(private router: Router, public permissions: PermissionsService) {

        this.tabs = {
            'statistics': 'Statistics'
        };

        if (permissions.can('leads.view')) {
            this.tabs['east-coast'] = 'East coast leads';
            this.tabs['west-coast'] = 'West coast leads';
            this.tabs['non-qualified'] = 'Non Qualified';
            this.tabs['removed'] = 'Removed';
            this.tabs['scheduled-callback'] = 'Scheduled Callbacks';
        }

        if (permissions.can('leads.import')) {
            this.tabs['import'] = 'Import';
        }

        if (permissions.can('leads.assignOpener')) {
            this.tabs['assign-opener'] = 'Assign opener';
        }

        if (permissions.can('dashboards.fs.view')) {
            this.tabs['global-search'] = 'Global search';
        }

        if (permissions.can('leads.import')) {
            this.tabs['lead-list'] = 'Lead list';
        }
    }

    public openTab(event, url: string){
        event.stopPropagation();
        this.router.navigate(['/leads/' + url]);
        return false;
    }

    public checkActiveModuleRoute(routeTime: string): boolean{

        //todo create Unified service

        let currentRoute = this.getCurrentRoute();
        return currentRoute === routeTime;
    }

    public getCurrentRouteName() {
        let currentRoute = this.getCurrentRoute();
        return this.tabs[currentRoute];
    }

    private getCurrentRoute() {
        let currentRoute = 'statistics';
        if(this.router.url !== '/leads'){
            currentRoute = this.router.url.split('?')[0].split('/')[2];
        }
        return currentRoute;
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/leads.component.ts